import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=5f3fd8ae&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fd8ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3fd8ae')) {
      api.createRecord('5f3fd8ae', component.options)
    } else {
      api.reload('5f3fd8ae', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=5f3fd8ae&scoped=true&", function () {
      api.rerender('5f3fd8ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t3MNNoTPJ676/JS/comp/Voucher-Unit.vue"
export default component.exports